import React from 'react';
import MainLayout from '../layouts/MainLayout';

const Ocorrencias = () => {
  return (
    <MainLayout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Ocorrências</h2>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded flex items-center">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          Nova Ocorrência
        </button>
      </div>
      
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 border-b">
          <h3 className="font-semibold">Filtros</h3>
        </div>
        <div className="p-4 grid grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Produto</label>
            <select className="w-full p-2 border rounded">
              <option>Todos</option>
              <option>Válvula de Controle A-370</option>
              <option>Sensor de Pressão X-290</option>
              <option>Bomba Centrífuga BC-450</option>
              <option>Válvula de Segurança VS-110</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Categoria de Defeito</label>
            <select className="w-full p-2 border rounded">
              <option>Todas</option>
              <option>Vazamento</option>
              <option>Falha elétrica</option>
              <option>Ruído excessivo</option>
              <option>Vibração</option>
              <option>Desalinhamento</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
            <select className="w-full p-2 border rounded">
              <option>Todos</option>
              <option>Aberto</option>
              <option>Em análise</option>
              <option>Concluído</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Período</label>
            <div className="flex items-center space-x-2">
              <input type="date" className="p-2 border rounded w-full" defaultValue="2025-05-01" />
              <span>até</span>
              <input type="date" className="p-2 border rounded w-full" defaultValue="2025-05-21" />
            </div>
          </div>
        </div>
        
        <div className="p-4 border-t flex justify-end">
          <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 mr-2 px-4 py-2 rounded">
            Limpar
          </button>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded flex items-center">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
            </svg>
            Filtrar
          </button>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 text-xs font-medium text-gray-500 uppercase">
              <tr>
                <th className="py-3 px-4 text-left">ID</th>
                <th className="py-3 px-4 text-left">Produto</th>
                <th className="py-3 px-4 text-left">Defeito</th>
                <th className="py-3 px-4 text-left">Sev.</th>
                <th className="py-3 px-4 text-left">Data</th>
                <th className="py-3 px-4 text-left">Lote</th>
                <th className="py-3 px-4 text-left">Qtde</th>
                <th className="py-3 px-4 text-left">Status</th>
                <th className="py-3 px-4 text-left">Causa Raiz</th>
                <th className="py-3 px-4 text-left">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr className="hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-blue-600">OC-2025-0489</td>
                <td className="py-3 px-4 text-sm">Válvula de Controle A-370</td>
                <td className="py-3 px-4 text-sm">Vazamento na vedação</td>
                <td className="py-3 px-4">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">4</span>
                </td>
                <td className="py-3 px-4 text-sm">20/05/2025</td>
                <td className="py-3 px-4 text-sm">L25050783</td>
                <td className="py-3 px-4 text-sm">12</td>
                <td className="py-3 px-4">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">Em análise</span>
                </td>
                <td className="py-3 px-4 text-sm">Em análise</td>
                <td className="py-3 px-4">
                  <div className="flex space-x-1">
                    <button className="p-1 text-indigo-600 hover:text-indigo-800" title="Ver detalhes">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                      </svg>
                    </button>
                    <button className="p-1 text-blue-600 hover:text-blue-800" title="Iniciar análise">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              {/* Adicione mais linhas conforme necessário */}
            </tbody>
          </table>
        </div>
        
        <div className="p-4 border-t flex justify-between items-center">
          <div className="text-sm text-gray-600">
            Mostrando 1-10 de 143 ocorrências
          </div>
          
          <div className="flex">
            <button className="border rounded-l px-3 py-1 hover:bg-gray-100 text-gray-600">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <button className="border-t border-b px-3 py-1 bg-blue-600 text-white font-medium">1</button>
            <button className="border-t border-b px-3 py-1 hover:bg-gray-100">2</button>
            <button className="border-t border-b px-3 py-1 hover:bg-gray-100">3</button>
            <button className="border-t border-b px-3 py-1 hover:bg-gray-100">4</button>
            <button className="border-t border-b px-3 py-1 hover:bg-gray-100">5</button>
            <button className="border rounded-r px-3 py-1 hover:bg-gray-100 text-gray-600">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Ocorrencias;